import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import ProfileAccessContent from '../../../../shared/ProfileAccessContent';

export type AccessScreenOwnProps = {};

export type AccessScreenProps = AccessScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'connect'>;
};

const AccessScreenScreen: React.FC<AccessScreenProps> = (props) => {
    return <ProfileAccessContent medicalProfileId={props.route.params.profileId} />;
};

export default React.memo(AccessScreenScreen);
